import $api from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import { Notification } from "@/core/services/api/interfaces/manager/Notification";

class NotificationEndpoint {
  public list(params: AxiosRequestConfig = {}) {
    return $api.get("manager/notifications", params);
  }

  public remove(notification: Notification) {
    return $api.delete(`manager/notifications/${notification.id}`);
  }

  public purge() {
    return $api.delete(`manager/notifications`);
  }
}

export default NotificationEndpoint;
